import DashboardHeader from "../../components/Dashboard/DashboardHeader";

const DashboardScreen = () => {
  return <DashboardHeader />;
};

export default DashboardScreen;
